// extracted by mini-css-extract-plugin
export default {"icon":"ContactPage_icon__vEvka","container":"ContactPage_container__HlH9+","heading":"ContactPage_heading__y-2O-","contactDetails":"ContactPage_contactDetails__DvRPn"};